import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22brand-fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/Google_Sans/GoogleSans-VariableFont_GRAD,opsz,wght.ttf%22,%22weight%22:%22100%20900%22,%22style%22:%22normal%22},{%22path%22:%22../../public/fonts/Google_Sans/GoogleSans-Italic-VariableFont_GRAD,opsz,wght.ttf%22,%22weight%22:%22100%20900%22,%22style%22:%22italic%22}],%22display%22:%22swap%22,%22variable%22:%22--font-brand-heading%22,%22fallback%22:[%22system-ui%22,%22sans-serif%22]}],%22variableName%22:%22fontHeading%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'fontHeading', 'fontHeading Fallback', system-ui, sans-serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
